// datacenter-hired — JS entry point.
// Compiled + minified by Rollup to assets/built/index.js.

// Import CSS so PostCSS extracts it to assets/built/index.css.
import "../css/index.css";

// Dark-mode toggle (footer). IIFE — runs on import for its side effects.
import "./toggle.js";

// Dynamic table of contents (article pages).
import toc from "./toc.js";

// Mobile hamburger navigation.
import mobileNav from "./mobile-nav.js";

toc();
mobileNav();
